import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTiposSocio } from 'services/servicioGet';
import { TipoGenerico } from 'utils/models/types';

interface TiposSocioState {
  tiposSocio: TipoGenerico[];
  loadingTiposSocio: boolean;
  errorTiposSocio: string | null;
}

// Estado inicial del slice
const initialState: TiposSocioState = {
  tiposSocio: [],
  loadingTiposSocio: false,
  errorTiposSocio: null,
};

// Thunk para obtener los alquileres
export const fetchTiposSocio = createAsyncThunk<TipoGenerico[], void, { rejectValue: string }>(
  'fetchTiposSocio',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getTiposSocio();
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de tipos de socio
const tiposSocioSlice = createSlice({
  name: 'tiposSocio',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTiposSocio.pending, state => {
        state.loadingTiposSocio = true;
        state.errorTiposSocio = null;
      })
      .addCase(fetchTiposSocio.fulfilled, (state, action) => {
        state.tiposSocio = action.payload;
        state.loadingTiposSocio = false;
      })
      .addCase(fetchTiposSocio.rejected, (state, action) => {
        state.loadingTiposSocio = false;
        state.errorTiposSocio = action.payload as string;
      });
  },
});

export default tiposSocioSlice.reducer;
